function fclTab() {
  document.addEventListener('click', function (e) {
    if (e.target.classList.contains('collection_tablinks')) {
      e.target.closest('.tp-fcl__main').classList.add('overlay-body');
      var buttonActiveCurrent = document.querySelector('.collection_tablinks.active')
      if (buttonActiveCurrent) {
        buttonActiveCurrent.classList.remove('active')
      }

      var dataTabIndex = e.target.getAttribute('data-tab-index')
      var parentItemResult = document.querySelector(`.parent-item-${dataTabIndex}`)

      var parentItemActiveCurrent = document.querySelector('.parent-item.active')

      // Effect
      if (!e.target.classList.contains('active')) {

        e.target.classList.add('active')
        e.target.closest('.tp-fcl__main').classList.remove('overlay-body');
      }

      if (parentItemActiveCurrent) {
        parentItemActiveCurrent.classList.remove('active')
        // parentItemActiveCurrent.style.color = '#a3a3a3'
      }

      if (parentItemResult) {
        parentItemResult.classList.add('active')
      }
    }
  })

  // mobile js
  if (document.querySelector('#tpbox-select')) {
    document.querySelector('#tpbox-select').addEventListener('change', function () {
      let val = this.value;
      let parents = document.querySelectorAll('.parent-item');
      parents.forEach(function (item) {
        // console.log(item)
        if (item.classList.contains('active')) {
          item.classList.remove('active');
        }
        var current_item = document.querySelector(`.parent-item-${val}`);
        current_item.classList.add('active');
      })
    })
  }
}
fclTab();

document.addEventListener("shopify:section:load", fclTab);
document.addEventListener("shopify:section:unload", fclTab);